module.exports = __webpack_public_path__ + "static/media/en_wco.694ce96a.png";